import { FunnelStepService } from '../../interfaces';

export class FunnelStepServerService implements FunnelStepService {
  updateScreensPath() {
    return;
  }

  getStepNumber() {
    return 0;
  }

  consumeResetReason() {
    return null;
  }
}
